//
import { ModuleLayout } from '@/components/reusable_components/next'

//
// import ProductCreateView from '@/views/Warehouse/WhProduct/create'
import ProductCreateView from '../../views/Warehouse/Item/newTabProduct/create/CreateMain'
import ProductListView from '@/views/Warehouse/WhProduct/list'
import ProductRepackingView from '@/views/Warehouse/WhProduct/repacking'
// import ProductUpdateView from '@/views/Warehouse/WhProduct/update'
import ProductUpdateView from '../../views/Warehouse/Item/newTabProduct/showEdit/ShowEditMain'

//
export default {
    path: 'products',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'product',
            component: ProductListView,
        },
        {
            path: 'create',
            name: 'product-create',
            component: ProductCreateView,
            meta: {
                title: 'Crear producto',
            },
        },
        {
            path: 'repacking/:id',
            name: 'product-children',
            component: ProductRepackingView,
            meta: {
                title: 'Asignar productos reenvasados',
            },
        },
        {
            path: ':id',
            name: 'product-update',
            component: ProductUpdateView,
            meta: {
                title: 'Datos del producto',
            },
        },
    ],
    meta: {
        title: 'Productos',
    },
}
